export const RESET_APP = 'RESET_APP'
export const SET_FOUND = 'SET_FOUND'
export const SET_ROUTE_NAMES = 'SET_ROUTE_NAMES'
